import { render, staticRenderFns } from "./DiBu.vue?vue&type=template&id=69c31204&scoped=true&"
import script from "./DiBu.vue?vue&type=script&lang=js&"
export * from "./DiBu.vue?vue&type=script&lang=js&"
import style0 from "./DiBu.vue?vue&type=style&index=0&id=69c31204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c31204",
  null
  
)

export default component.exports